import { render, staticRenderFns } from "./HotelDetailsNearTab.vue?vue&type=template&id=31663794&"
import script from "./HotelDetailsNearTab.vue?vue&type=script&lang=js&"
export * from "./HotelDetailsNearTab.vue?vue&type=script&lang=js&"
import style0 from "./HotelDetailsNearTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports